const InfoLine = () => {
  return (
    <div role='alert' className='gov-alert gov-alert--copy'>
      <div className='gov-alert__content'>
        <p>
          Vážení zadavatelé,
          <br />
          od čtvrtka 17. 4. 2025 od 18:00 není možné z důvodu plánované odstávky přihlášení, registrace a podání
          formulářů.
          <br/>
          Uveřejněné formuláře jsou k dispozici pouze pro čtení.
          <br/>
          <br />
          Od úterý 22. 4. 2025 od 8:00 bude Věstník veřejných zakázek kompletně nedostupný.
          <br />
          Věstník veřejných zakázek bude znovu zprovozněn ve čtvrtek 24. dubna 2025 od 8:00. Omlouváme se za vzniklé
          komplikace.
        </p>
      </div>
    </div>
  )
}

export default InfoLine
